import { Button, Dialog, IconButton, Popover, TextField, Tooltip } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import companyService from 'src/services/company.service'
import userService from 'src/services/user.service'
import Spacer from '../components/Spacer'
import { ReactComponent as SearchIcon } from '../../common/icons/search.svg'
import { InputText } from 'src/pages/settings/components/phishingSimulations'
import CustomCheckbox from '../components/CustomCheckbox'
import { SnackBarContext } from 'src/App'
import { LoadingButton } from '@mui/lab'

export function WorkspaceSelect() {
  const [search, setSearch] = useState('')
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState('')
  const [companies, setCompanies] = useState([])
  const [companiesFiltred, setCompaniesFiltred] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)
  const [addWorkspaceOpen, setAddWorkspaceOpen] = useState(false)
  const [termsAgree, setTermsAgree] = useState(false)
  const [loading, setLoading] = useState(false)
  const [img, setImg] = useState('')

  const buttonRef = useRef(null)
  const currentCompany = companies?.find(el => el.current)

  const { setSuccessMessage } = useContext(SnackBarContext)

  const addCompany = () => {
    const nameFiltred = name.trim()
    if (!nameFiltred) {
      setName(nameFiltred)
      setNameError('Name required')
      return
    }
    setLoading(true)
    companyService
      .addCompany(name)
      .then(resp => {
        switchToCompany(resp.data.id)
        setSuccessMessage('New Workspace created')
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        setLoading(true)
      })
  }
  const switchToCompany = id => {
    if (id == currentCompany.id) {
      return
    }

    companyService
      .switchToCompany(id)
      .then(() => {
        window.location.href = '/'
      })
      .catch(err => {
        console.error(err)
      })
  }

  const open = Boolean(anchorEl)

  useEffect(() => {
    userService.getAccountData().then(resp => {
      setCompanies(resp.data.companies)
      setCompaniesFiltred(resp.data.companies)
    })

    companyService.getCompanyLogo().then(resp => {
      setImg(resp.data.logoUrl)
    })
  }, [])

  useEffect(() => {
    const res = companies.filter(el => el.name.toLowerCase().includes(search.toLowerCase()))
    setCompaniesFiltred(res)
  }, [search])

  return (
    <div className='ws-select'>
      <div
        ref={buttonRef}
        className='row ws-select-main row-center'
        onClick={event => {
          setAnchorEl(event.currentTarget)
        }}
      >
        <div className='company-avatar' style={{ background: img && '#F4F5F9' }}>
          {img ? (
            <img width={'100%'} src={img} alt='' />
          ) : (
            <div
              style={{
                fontWeight: '600',
                fontSize: '16px',
                lineHeight: '24px',
                textAlign: 'center',
                cursor: 'pointer'
              }}
            >
              {currentCompany?.name.slice(0, 1).toUpperCase()}
            </div>
          )}
        </div>

        <Tooltip arrow title={currentCompany?.name}>
          <span className='text-shrink-1' style={{ fontWeight: 600, maxWidth: 158 }}>
            {currentCompany?.name}
          </span>
        </Tooltip>
        <Spacer />
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M6.25 12.5L10 16.25L13.75 12.5' stroke='#76767D' strokeLinecap='round' strokeLinejoin='round' />
          <path d='M13.75 7.5L10 3.75L6.25 7.5' stroke='#76767D' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>

      <Popover
        open={open}
        onClose={() => {
          setAnchorEl(null)
          setSearch('')
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '16px',
            boxShadow:
              '0px 35px 77px 0px #0000000D, 0px 139px 139px 0px #0000000A, 0px 557px 223px 0px #00000003, 0px 870px 243px 0px #00000000'
          }
        }}
      >
        <div style={{ width: 290, padding: 12 }} className='column'>
          <div className='row row-center' style={{ marginBottom: 12 }}>
            <span
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: '#76767D'
              }}
            >
              {companies?.length} Workspaces
            </span>
            <Spacer />
            <IconButton onClick={() => setAddWorkspaceOpen(true)} size='sm'>
              <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z'
                  stroke='#0246F8'
                  strokeMiterlimit='10'
                />
                <path d='M6.875 10H13.125' stroke='#0246F8' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M10 6.875V13.125' stroke='#0246F8' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
            </IconButton>
          </div>

          <TextField
            sx={{
              width: '100%',
              marginBottom: '12px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                border: '1px solid #E7E7EE',
                background: '#fff',
                width: '100%'
              }
            }}
            InputProps={{
              endAdornment: <SearchIcon />
            }}
            onChange={e => setSearch(e.target.value)}
            value={search}
            size='small'
            placeholder='Search Workspace'
          />

          <div style={{ maxHeight: 480, overflow: 'auto' }} className='column'>
            {companiesFiltred?.map(el => (
              <div
                className={'row row-center company-list-item ' + (el.current ? 'active' : '')}
                key={el.id}
                onClick={() => switchToCompany(el.id)}
              >
                <div className='company-avatar'>{el?.name.slice(0, 1).toUpperCase()}</div>
                <Tooltip arrow title={el.name}>
                  <span
                    className='text-shrink-1'
                    style={{
                      fontWeight: 700,
                      fontSize: 14,
                      maxWidth: 170
                    }}
                  >
                    {el.name}
                  </span>
                </Tooltip>
                <Spacer />

                {el.current && (
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M20.25 6.75L9.75 17.2495L4.5 12'
                      stroke='#1B1B26'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                )}
              </div>
            ))}
          </div>
        </div>
      </Popover>

      <Dialog
        sx={{ '& .MuiPaper-root': { borderRadius: '22px' } }}
        open={addWorkspaceOpen}
        onClose={() => {
          setAddWorkspaceOpen(false)
          setName('')
          setNameError('')
        }}
      >
        <div className='column' style={{ padding: '45px 20px', width: 546 }}>
          <div style={{ marginBottom: 40 }} className='row row-center'>
            <span style={{ fontSize: 35, fontWeight: 900 }}>Create a new workspace</span>
            <Spacer />
            <IconButton
              onClick={() => {
                setAddWorkspaceOpen(false)
                setName('')
                setNameError('')
              }}
              size='sm'
            >
              <svg width='32' height='33' viewBox='0 0 32 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M25 7.5L7 25.5'
                  stroke='#1B1B26'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M25 25.5L7 7.5'
                  stroke='#1B1B26'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </IconButton>
          </div>
          <InputText
            error={!!nameError}
            fullWidth
            sx={{
              borderRadius: '20px',
              marginBottom: '12px'
            }}
            label='Name'
            variant='standard'
            onChange={e => {
              setName(e.target.value)
              setNameError('')
            }}
            value={name || ''}
          />
          {nameError && <p className='error-text'>{nameError}</p>}

          <div className='row row-center'>
            <CustomCheckbox checked={termsAgree} onClick={() => setTermsAgree(prev => !prev)} />
            <p>
              I have read and agree to{' '}
              <a
                style={{
                  color: '#0246F8',
                  textDecoration: 'none'
                }}
                href='https://admin.gallaghercdc.cyberlift.ai/assets/TERMS%20&%20CONDITIONS%20FOR%20THE%20USE%20OF%20THE%20PROVIDER%20SERVICES%20(EULA).pdf'
                target='_blank'
                rel='noreferrer'
              >
                the Terms and Conditions for the use of the provider services (EULA)
              </a>
            </p>
          </div>

          <div className='row'>
            <Button
              onClick={() => {
                setAddWorkspaceOpen(false)
                setName('')
                setNameError('')
              }}
              sx={{
                textTransform: 'none',
                fontFamily: 'Plus Jakarta Sans',
                borderRadius: '14px',
                color: '#6123FF',
                borderColor: '#6123FF',
                flex: '1',
                margin: '24px 16px 24px 32px'
              }}
              variant={'outlined'}
            >
              Cancel
            </Button>
            <LoadingButton
              loading={loading}
              disabled={name.length == 0 || !termsAgree}
              onClick={addCompany}
              sx={{
                textTransform: 'none',
                fontFamily: 'Plus Jakarta Sans',
                borderRadius: '14px',
                backgroundColor: '#6123FF',
                flex: '1',
                margin: '24px 32px 24px 0px'
              }}
              variant={'contained'}
            >
              Create
            </LoadingButton>
          </div>
        </div>
      </Dialog>
    </div>
  )
}
